import script from "./gameCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameCard.vue?vue&type=script&setup=true&lang=ts"

import "./gameCard.vue?vue&type=style&index=0&id=37199d34&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37199d34"]])

export default __exports__